/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RichiesteTimbratureApprovazioniStoricoUpdateDTO
 */
export interface RichiesteTimbratureApprovazioniStoricoUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniStoricoUpdateDTO
     */
    tipo?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RichiesteTimbratureApprovazioniStoricoUpdateDTO
     */
    isApprovato?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteTimbratureApprovazioniStoricoUpdateDTO
     */
    data?: Date;
}

/**
 * Check if a given object implements the RichiesteTimbratureApprovazioniStoricoUpdateDTO interface.
 */
export function instanceOfRichiesteTimbratureApprovazioniStoricoUpdateDTO(value: object): value is RichiesteTimbratureApprovazioniStoricoUpdateDTO {
    return true;
}

export function RichiesteTimbratureApprovazioniStoricoUpdateDTOFromJSON(json: any): RichiesteTimbratureApprovazioniStoricoUpdateDTO {
    return RichiesteTimbratureApprovazioniStoricoUpdateDTOFromJSONTyped(json, false);
}

export function RichiesteTimbratureApprovazioniStoricoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RichiesteTimbratureApprovazioniStoricoUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'tipo': json['tipo'] == null ? undefined : json['tipo'],
        'isApprovato': json['isApprovato'] == null ? undefined : json['isApprovato'],
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
    };
}

export function RichiesteTimbratureApprovazioniStoricoUpdateDTOToJSON(json: any): RichiesteTimbratureApprovazioniStoricoUpdateDTO {
    return RichiesteTimbratureApprovazioniStoricoUpdateDTOToJSONTyped(json, false);
}

export function RichiesteTimbratureApprovazioniStoricoUpdateDTOToJSONTyped(value?: RichiesteTimbratureApprovazioniStoricoUpdateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tipo': value['tipo'],
        'isApprovato': value['isApprovato'],
        'data': value['data'] == null ? undefined : ((value['data']).toISOString()),
    };
}

